import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import Heading from "../../elements/heading";
import CalendarDatePicker from "../../react-components/calendar-date-picker";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";

const TimeAndDate = ({ heading, carDeliverySubmit, termsCheckbox, ageCheckbox, calendarProps, showCheckboxContainer, testDriveSubmit }) => {
  const [termsChecked, setTermsChecked] = useState(false);
  const [ageChecked, setAgeChecked] = useState(false);
  const onTermsChange = evt => {
    setTermsChecked(evt);
  };

  const onAgeChange = evt => {
    setAgeChecked(evt);
  };

  return (
    <section className="time-and-date grid">
      <div className="time-and-date-body">
        <Heading {...heading} className="time-and-date-heading" typographyClass={"type-h4"} />
        <CalendarDatePicker {...calendarProps} />

        <div className="time-and-date-booking">
          {showCheckboxContainer && (
            {/* <>
              <div className="terms-checkbox">
                <Checkbox
                  {...{
                    ...termsCheckbox,
                    onChange: evt => onTermsChange(evt)
                  }}
                />
              </div>
              <div className="age-checkbox">
                <Checkbox {...{ ...ageCheckbox, onChange: evt => onAgeChange(evt) }} />
              </div>
              <div className="submit">
                <PrimaryButton
                  {...{
                    ...carDeliverySubmit,
                    isDisabled: carDeliverySubmit?.isDisabled || !termsChecked || !ageChecked
                  }}
                />
              </div>
            </> */}
          )}
          {!showCheckboxContainer && <PrimaryButton {...carDeliverySubmit} />}
        </div>
      </div>
    </section>
  );
};

TimeAndDate.propTypes = {
  // heading: PropTypes.object,
  testDriveSubmit: PropTypes.object,
  carDeliverySubmit: PropTypes.object,
  termsCheckbox: PropTypes.object,
  ageCheckbox: PropTypes.object,
  calendarProps: PropTypes.object
};

export default TimeAndDate;
